import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import ProviderInfo from './ProviderInfo';
import extractText from 'flarum/common/utils/extractText';
import Icon from 'flarum/common/components/Icon';
export default class LinkStatus extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      loading: false
    });
  }
  view() {
    return m("div", {
      className: "LinkedAccountsList-item LinkedAccountsList-item--".concat(this.attrs.provider.name())
    }, this.iconView(), this.statusView(), this.actionView());
  }
  iconView() {
    return m("div", {
      className: "LinkedAccountsList-item-icon"
    }, m(Icon, {
      name: this.attrs.provider.icon(),
      className: "Provider-Icon Provider-Icon--".concat(this.attrs.provider.name())
    }));
  }
  statusView() {
    const provider = this.attrs.provider;
    return m(ProviderInfo, {
      provider: provider
    });
  }
  actionView() {
    var _app$session$user;
    const provider = this.attrs.provider;
    const user = this.attrs.user;
    if (provider.linked()) {
      return m("div", {
        className: "LinkedAccountsList-item-actions"
      }, m(Button, {
        className: "Button FoFLogInButton LogInButton--".concat(provider.name(), " LogInButton").concat(provider.linked() ? '--linked' : '--unlinked'),
        icon: provider.icon(),
        onclick: () => this.deleteProvider(provider),
        loading: this.state.loading
      }, app.translator.trans('fof-oauth.forum.unlink')));
    } else if (!provider.orphaned() && (user.id() === ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id()) || !app.forum.attribute('fofOauthModerate'))) {
      const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
      const linkUrl = "".concat(app.forum.attribute('baseUrl'), "/auth/").concat(provider.name(), "?linkTo=").concat(user.id(), "&returnTo=").concat(returnTo);
      return m("div", {
        className: "LinkedAccountsList-item-actions"
      }, m(Button, {
        className: "Button FoFLogInButton LogInButton--".concat(provider.name()),
        icon: provider.icon(),
        onclick: e => {
          e.preventDefault();
          window.location.href = linkUrl;
        },
        loading: this.state.loading
      }, app.translator.trans("fof-oauth.forum.log_in.with_".concat(provider.name(), "_button"), {
        provider: app.translator.trans("fof-oauth.forum.providers.".concat(provider.name()))
      })));
    }
    return null;
  }
  async deleteProvider(provider) {
    if (confirm(extractText(app.translator.trans('fof-oauth.forum.user.settings.linked-account.unlink-confirm', {
      provider: app.translator.trans("fof-oauth.forum.providers.".concat(provider.name()))
    })))) {
      var _this$attrs$refresh, _this$attrs;
      this.state.loading = true;
      await provider.delete();
      await ((_this$attrs$refresh = (_this$attrs = this.attrs).refresh) == null ? void 0 : _this$attrs$refresh.call(_this$attrs));
      this.state.loading = false;
    }
  }
}
flarum.reg.add('fof-oauth', 'forum/components/LinkStatus', LinkStatus);